export const NonExpressLottieFrames = [0, 78];
export const NonExpressLottieTransitionFrame = 26;

export const ExpressLottieFrames = [0, 250];
export const ExpressLottieTransitionFrame = 125;

export const BoltLottieTransitionFrame = 24;

export const OtgLottieFrames = {
    initial: 270,
    final: 580,
};

export const BoltLottieFrames = {
    initial: 2,
    final: 250,
};

export const BoltStampLottieFrames = {
    initial: 60,
    final: 479,
};

export const BoltStampLottieFinalStateFrames = {
    initial: 474,
    final: 479,
};

export const lottieProps = {
    loop: false,
    forwardSpeed: 1,
    backwardSpeed: 1,
    playIfVisible: true,
};
export const OtgLottieDelay = {
    isExpress: 3000,
    isNonExpress: 1000,
};

export const CLEAR_IMAGE = {
    ID: {
        FILLED_SUBTLE: "/portal/static-assets/hcms/clear-filled-subtle.png",
        FILLED_BLACK: "/portal/static-assets/hcms/clear-filled-black.png",
    },
    HEIGHT: "16px",
    WIDTH: "16px",
};
